export default __webpack_public_path__ + "static/media/IBEW-use-fontawesome_location-dot-ico.514be247.svg";